export default __webpack_public_path__ + "static/media/program.02a459d5.png";